import { color, SaleStatus } from '@enums/enums';

export interface credentials {
  email: string;
  password: string;
}

export interface API {
  data: Product | Product[];
}

export interface PaymentMethod {
  id: number;
  IBAN: string;
  type: string;
}

export interface Category {
  id: number;
  name: string;
  href: string;
  checked?: boolean;
  expanded?: boolean;
  children?: Category[];
  isLoading?: boolean;
}

export interface FlatCategoryNode {
  expandable: boolean;
  name: string;
  level: number;
  id: number;
  href: string;
}

export interface Business extends CustomerInfo {
  id: number;
  business_name: string;
  region: string;
  paymentMethod: PaymentMethod;
  isExpanded?: boolean;
}

export interface Transaction {
  id: number;
  date: string;
  business: Business;
  consumer: CustomerInfo;
  order_status: OrderStatus;
}

export interface DeliveryMethod {
  name: string;
  value: string;
  price: number;
  disabled: boolean;
  description: string;
}

export interface Color {
  id: number;
  name: string;
  backgroundColor: string;
  ringColor: string;
  value: string;
  available?: boolean;
  isLoading: boolean;
}

export interface Size {
  id: number;
  name: string;
  value: string;
  available: boolean;
  quantity: number;
}

export interface ProductProperty {
  id: number;
  name: string;
}

export interface ProductLinings {
  id: number;
  name: string;
}

export interface ProductCompositions {
  id: number;
  name: string;
}

export enum ProductWearerType {
  Men = 'MEN',
  Women = 'WOMEN',
  Kid = 'KID',
}

export interface Product {
  id?: number;
  sale: number;
  external_id: string;
  name: string;
  category: Category;
  brand: string;
  description: string;
  old_price: number;
  price: number;
  properties?: ProductProperty[];
  linings?: ProductLinings[];
  compositions?: ProductCompositions[];
  variants: ProductVariant[];
  wearer_type: ProductWearerType;
  isLoading: boolean;
}
export interface ProductVariant {
  id?: number;
  color: Color;
  sizes: Size[];
  quantity: number;
  photos?: string[];
  isEdit?: boolean;
}
/**
 * For basket objects
 */
export interface Article {
  id?: number;
  parentId: number;
  name: string;
  categories: string;
  brand: string;
  description: string;
  price: number;
  old_price: number;
  color: string;
  size: string;
  quantity: number;
  photo?: string;
}
export interface Basket {
  id: number;
  total?: number;
  NoDiscountTotal?: number;
  articles: Article[];
}

export interface Order {
  id: number;
  settled_date: Date;
  status: SaleStatus;
  customer: CustomerInfo;
  deliveryAddress: Address;
  invoiceAddress: Address;
  createdAt: Date;
  updatedAt: Date;
  items: OrderItem[];
  deliveryMethode: DeliveryMethod;
  shippedOn?: Date;
  receivedOn?: Date;
  returnedOn?: Date;
  closedOn?: Date;
  discountCode?: string;
}

export interface OrderItem {
  quantity: number;
  product: Product;
  size: { id: number; name: string; value: string };
  color: { id: number; name: string; value: string };
}

export interface OrderStatus {
  id: string;
  name: SaleStatus;
  description: string;
  color: color;
  date?: string;
}
export interface CustomerInfo {
  firstname: string;
  lastname: string;
  email?: string;
  phone?: string;
}

export interface Address {
  street: string;
  number: string;
  street2?: string;
  ZIP: number;
  city: string;
  state: string;
  country: string;
}

export interface DialogData {
  email: string;
}

export interface ListItem {
  id: string;
  name: string;
  description: string;
}

export class TreeModel {
  children!: Array<TreeModel>;
  name!: string;
}

/*
 * Shopping menu interfaces
 */
export interface Section {
  name: string;
  href: string;
  links: QuickLinks[];
  categories?: Link[];
}
export interface QuickLinks {
  name: string;
  href: string;
  id?: string;
  links: Link[];
}
export interface Link {
  name: string;
  imgUrl?: string;
  altText?: string;
  href: string;
}

export interface Secret {
  name: string;
  url: string;
  secret: string;
}
